import { render, staticRenderFns } from "./PushDataRoom.vue?vue&type=template&id=213b1da6&scoped=true&"
import script from "./PushDataRoom.vue?vue&type=script&lang=js&"
export * from "./PushDataRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213b1da6",
  null
  
)

export default component.exports